var THREE = require("three");
THREE.OrbitControls = require("three-orbit-controls")(THREE);